import { Product } from '../api/productsApi';

// Mock product data for testing the UI
export const mockProducts: Product[] = [
  {
    _id: '1',
    sellerId: 'seller-123',
    title: 'iPhone 14 Pro Max 256GB',
    description: 'Latest iPhone with A16 Bionic chip, 48MP camera system, and Always-On display. Comes with 1 year warranty.',
    price: 1299,
    discountPrice: 1099,
    stock: 45,
    stockQuantity: 45,
    category: 'Electronics',
    brand: 'Apple',
    sku: 'IPH14PM-256-BLK',
    images: [
      'https://images.unsplash.com/photo-1678652197831-2d180705cd2c?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1678911820864-e5c67c6e98b4?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1678685888221-f49d3a87b4e7?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: true,
    rating: 4.8,
    averageRating: 4.8,
    reviewCount: 234,
    totalReviews: 234,
    sold: 189,
    totalSold: 189,
    views: 3456,
    tags: ['smartphone', 'apple', 'premium', 'flagship'],
    createdAt: '2024-01-15T10:30:00.000Z',
    updatedAt: '2024-03-20T14:22:00.000Z',
  },
  {
    _id: '2',
    title: 'Samsung Galaxy S24 Ultra',
    description: 'Flagship Samsung phone with S Pen, 200MP camera, and AI features.',
    price: 1199,
    stock: 8,
    stockQuantity: 8,
    category: 'Electronics',
    brand: 'Samsung',
    sku: 'SAMS24U-512-TIT',
    images: [
      'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1598327105666-5b89351aff97?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: false,
    rating: 4.6,
    averageRating: 4.6,
    reviewCount: 87,
    totalReviews: 87,
    sold: 56,
    totalSold: 56,
    views: 1234,
    tags: ['smartphone', 'samsung', 'android'],
    createdAt: '2024-02-10T09:15:00.000Z',
    updatedAt: '2024-03-19T11:30:00.000Z',
  },
  {
    _id: '3',
    title: 'MacBook Pro 16" M3 Max',
    description: 'Professional laptop with M3 Max chip, 48GB RAM, 1TB SSD. Perfect for developers and creators.',
    price: 3499,
    discountPrice: 3299,
    stock: 12,
    stockQuantity: 12,
    category: 'Electronics',
    brand: 'Apple',
    sku: 'MBP16-M3MAX-1TB',
    images: [
      'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: true,
    rating: 4.9,
    averageRating: 4.9,
    reviewCount: 156,
    totalReviews: 156,
    sold: 78,
    totalSold: 78,
    views: 2890,
    tags: ['laptop', 'macbook', 'professional', 'developer'],
    createdAt: '2024-01-20T14:45:00.000Z',
    updatedAt: '2024-03-21T16:00:00.000Z',
  },
  {
    _id: '4',
    title: 'Sony WH-1000XM5 Headphones',
    description: 'Industry-leading noise canceling wireless headphones with premium sound quality.',
    price: 399,
    discountPrice: 349,
    stock: 3,
    stockQuantity: 3,
    category: 'Electronics',
    brand: 'Sony',
    sku: 'SONY-WH1000XM5-BLK',
    images: [
      'https://images.unsplash.com/photo-1546435770-a3e426bf472b?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: false,
    rating: 4.7,
    averageRating: 4.7,
    reviewCount: 312,
    totalReviews: 312,
    sold: 245,
    totalSold: 245,
    views: 4567,
    tags: ['headphones', 'wireless', 'noise-canceling'],
    createdAt: '2023-12-05T08:20:00.000Z',
    updatedAt: '2024-03-22T10:15:00.000Z',
  },
  {
    _id: '5',
    title: 'Nike Air Max 2024',
    description: 'Premium running shoes with Max Air cushioning and breathable mesh upper.',
    price: 189,
    stock: 0,
    stockQuantity: 0,
    category: 'Clothing & Shoes',
    brand: 'Nike',
    sku: 'NIKE-AIRMAX24-10',
    images: [
      'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: false,
    rating: 4.5,
    averageRating: 4.5,
    reviewCount: 89,
    totalReviews: 89,
    sold: 134,
    totalSold: 134,
    views: 2345,
    tags: ['shoes', 'running', 'sports', 'nike'],
    createdAt: '2024-02-28T11:00:00.000Z',
    updatedAt: '2024-03-23T09:00:00.000Z',
  },
  {
    _id: '6',
    title: 'Levi\'s 501 Original Jeans',
    description: 'Classic straight-leg jeans. 100% cotton denim. Available in multiple washes.',
    price: 89,
    discountPrice: 69,
    stock: 67,
    stockQuantity: 67,
    category: 'Clothing & Shoes',
    brand: 'Levi\'s',
    sku: 'LEVIS-501-32-34',
    images: [
      'https://images.unsplash.com/photo-1542272604-787c3835535d?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1541099649105-f69ad21f3246?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: false,
    rating: 4.4,
    averageRating: 4.4,
    reviewCount: 456,
    totalReviews: 456,
    sold: 523,
    totalSold: 523,
    views: 6789,
    tags: ['jeans', 'denim', 'casual', 'classic'],
    createdAt: '2023-11-10T13:30:00.000Z',
    updatedAt: '2024-03-15T12:00:00.000Z',
  },
  {
    _id: '7',
    title: 'The Great Gatsby - Hardcover',
    description: 'Classic American novel by F. Scott Fitzgerald. Premium hardcover edition with dust jacket.',
    price: 24.99,
    stock: 156,
    stockQuantity: 156,
    category: 'Books',
    brand: 'Scribner',
    sku: 'BOOK-GATSBY-HC',
    images: [
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: false,
    rating: 4.9,
    averageRating: 4.9,
    reviewCount: 1234,
    totalReviews: 1234,
    sold: 2341,
    totalSold: 2341,
    views: 8901,
    tags: ['book', 'classic', 'literature', 'fiction'],
    createdAt: '2023-10-01T10:00:00.000Z',
    updatedAt: '2024-03-10T15:30:00.000Z',
  },
  {
    _id: '8',
    title: 'Instant Pot Duo 7-in-1',
    description: 'Multi-functional pressure cooker. 6 Quart capacity. Pressure cook, slow cook, rice cooker, and more.',
    price: 99,
    discountPrice: 79,
    stock: 23,
    stockQuantity: 23,
    category: 'Home & Kitchen',
    brand: 'Instant Pot',
    sku: 'INST-DUO-6QT',
    images: [
      'https://images.unsplash.com/photo-1585515320310-259814833133?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: true,
    rating: 4.6,
    averageRating: 4.6,
    reviewCount: 678,
    totalReviews: 678,
    sold: 456,
    totalSold: 456,
    views: 5432,
    tags: ['kitchen', 'appliance', 'pressure-cooker', 'instant-pot'],
    createdAt: '2024-01-05T09:30:00.000Z',
    updatedAt: '2024-03-18T11:45:00.000Z',
  },
  {
    _id: '9',
    title: 'Yoga Mat Premium 6mm',
    description: 'Non-slip yoga mat with carrying strap. Eco-friendly TPE material. Perfect for yoga, pilates, and fitness.',
    price: 39.99,
    stock: 89,
    stockQuantity: 89,
    category: 'Sports & Outdoors',
    brand: 'Gaiam',
    sku: 'YOGA-MAT-6MM-BLUE',
    images: [
      'https://images.unsplash.com/photo-1601925260368-ae2f83cf8b7f?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: false,
    rating: 4.3,
    averageRating: 4.3,
    reviewCount: 234,
    totalReviews: 234,
    sold: 567,
    totalSold: 567,
    views: 3456,
    tags: ['yoga', 'fitness', 'exercise', 'mat'],
    createdAt: '2023-12-20T14:00:00.000Z',
    updatedAt: '2024-03-12T16:20:00.000Z',
  },
  {
    _id: '10',
    title: 'Gaming Chair RGB LED',
    description: 'Ergonomic gaming chair with lumbar support, adjustable armrests, and RGB lighting.',
    price: 299,
    discountPrice: 249,
    stock: 5,
    stockQuantity: 5,
    category: 'Furniture',
    brand: 'Secretlab',
    sku: 'GAME-CHAIR-RGB-BLK',
    images: [
      'https://images.unsplash.com/photo-1598550476439-6847785fcea6?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1580480055273-228ff5388ef8?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: true,
    rating: 4.7,
    averageRating: 4.7,
    reviewCount: 189,
    totalReviews: 189,
    sold: 234,
    totalSold: 234,
    views: 4567,
    tags: ['gaming', 'chair', 'furniture', 'ergonomic'],
    createdAt: '2024-02-15T10:30:00.000Z',
    updatedAt: '2024-03-20T13:15:00.000Z',
  },
  {
    _id: '11',
    title: 'Mechanical Keyboard RGB',
    description: 'Cherry MX Blue switches, RGB backlight, programmable keys, aluminum frame.',
    price: 149,
    stock: 34,
    stockQuantity: 34,
    category: 'Electronics',
    brand: 'Corsair',
    sku: 'KB-MECH-RGB-BLUE',
    images: [
      'https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1595225476474-87563907a212?w=800&h=1000&fit=crop',
    ],
    status: 'pending',
    isFeatured: false,
    rating: 4.5,
    averageRating: 4.5,
    reviewCount: 145,
    totalReviews: 145,
    sold: 289,
    totalSold: 289,
    views: 2345,
    tags: ['keyboard', 'mechanical', 'gaming', 'rgb'],
    createdAt: '2024-03-01T11:00:00.000Z',
    updatedAt: '2024-03-22T09:30:00.000Z',
  },
  {
    _id: '12',
    title: 'Wireless Mouse Ergonomic',
    description: 'Vertical ergonomic mouse to reduce wrist strain. 2400 DPI, 6 buttons, rechargeable battery.',
    price: 49.99,
    stock: 0,
    stockQuantity: 0,
    category: 'Electronics',
    brand: 'Logitech',
    sku: 'MOUSE-ERGO-VERT',
    images: [
      'https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: false,
    rating: 4.4,
    averageRating: 4.4,
    reviewCount: 267,
    totalReviews: 267,
    sold: 456,
    totalSold: 456,
    views: 3456,
    tags: ['mouse', 'wireless', 'ergonomic', 'office'],
    createdAt: '2024-01-10T09:00:00.000Z',
    updatedAt: '2024-03-23T10:00:00.000Z',
  },
  {
    _id: '13',
    title: 'Smart Watch Series 9',
    description: 'Fitness tracker with heart rate monitor, GPS, sleep tracking, and 7-day battery life.',
    price: 349,
    stock: 28,
    stockQuantity: 28,
    category: 'Electronics',
    brand: 'Fitbit',
    sku: 'SMART-WATCH-S9',
    images: [
      'https://images.unsplash.com/photo-1579586337278-3befd40fd17a?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1434494878577-86c23bcb06b9?w=800&h=1000&fit=crop',
    ],
    status: 'inactive',
    isFeatured: false,
    rating: 4.2,
    averageRating: 4.2,
    reviewCount: 178,
    totalReviews: 178,
    sold: 312,
    totalSold: 312,
    views: 2890,
    tags: ['smartwatch', 'fitness', 'wearable', 'health'],
    createdAt: '2024-01-25T15:30:00.000Z',
    updatedAt: '2024-03-19T14:00:00.000Z',
  },
  {
    _id: '14',
    title: 'Coffee Maker Programmable',
    description: '12-cup programmable coffee maker with thermal carafe. Auto shut-off and brew strength control.',
    price: 89.99,
    discountPrice: 74.99,
    stock: 45,
    stockQuantity: 45,
    category: 'Home & Kitchen',
    brand: 'Cuisinart',
    sku: 'COFFEE-PROG-12CUP',
    images: [
      'https://images.unsplash.com/photo-1517668808822-9ebb02f2a0e6?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: false,
    rating: 4.6,
    averageRating: 4.6,
    reviewCount: 523,
    totalReviews: 523,
    sold: 678,
    totalSold: 678,
    views: 5678,
    tags: ['coffee', 'kitchen', 'appliance', 'programmable'],
    createdAt: '2023-11-15T10:00:00.000Z',
    updatedAt: '2024-03-14T12:30:00.000Z',
  },
  {
    _id: '15',
    title: 'USB-C Hub 7-in-1',
    description: 'Multiport adapter with HDMI 4K, USB 3.0, SD/TF card reader, and USB-C charging port.',
    price: 39.99,
    stock: 92,
    stockQuantity: 92,
    category: 'Electronics',
    brand: 'Anker',
    sku: 'USB-HUB-7IN1',
    images: [
      'https://images.unsplash.com/photo-1625948515291-69613efd103f?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: false,
    rating: 4.5,
    averageRating: 4.5,
    reviewCount: 345,
    totalReviews: 345,
    sold: 789,
    totalSold: 789,
    views: 4321,
    tags: ['usb-c', 'hub', 'adapter', 'accessory'],
    createdAt: '2024-02-05T11:15:00.000Z',
    updatedAt: '2024-03-16T15:45:00.000Z',
  },
  {
    _id: '16',
    title: 'Backpack Travel 40L',
    description: 'Water-resistant travel backpack with laptop compartment, USB charging port, and multiple pockets.',
    price: 79.99,
    stock: 6,
    stockQuantity: 6,
    category: 'Bags & Luggage',
    brand: 'SwissGear',
    sku: 'BKPK-TRVL-40L-BLK',
    images: [
      'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1622260614153-03223fb72052?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: false,
    rating: 4.7,
    averageRating: 4.7,
    reviewCount: 289,
    totalReviews: 289,
    sold: 445,
    totalSold: 445,
    views: 3789,
    tags: ['backpack', 'travel', 'luggage', 'laptop'],
    createdAt: '2024-01-30T13:00:00.000Z',
    updatedAt: '2024-03-21T11:00:00.000Z',
  },
  {
    _id: '17',
    title: 'LED Desk Lamp Dimmable',
    description: 'Modern LED desk lamp with touch control, 5 color modes, USB charging port, and adjustable arm.',
    price: 45.99,
    discountPrice: 36.99,
    stock: 67,
    stockQuantity: 67,
    category: 'Home & Office',
    brand: 'TaoTronics',
    sku: 'LAMP-DESK-LED-WHT',
    images: [
      'https://images.unsplash.com/photo-1507473885765-e6ed057f782c?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: true,
    rating: 4.4,
    averageRating: 4.4,
    reviewCount: 412,
    totalReviews: 412,
    sold: 678,
    totalSold: 678,
    views: 4567,
    tags: ['lamp', 'led', 'desk', 'office', 'dimmable'],
    createdAt: '2024-02-12T09:30:00.000Z',
    updatedAt: '2024-03-17T14:15:00.000Z',
  },
  {
    _id: '18',
    title: 'Bluetooth Speaker Waterproof',
    description: 'Portable wireless speaker with 360° sound, 20-hour battery, IPX7 waterproof rating.',
    price: 69.99,
    stock: 2,
    stockQuantity: 2,
    category: 'Electronics',
    brand: 'JBL',
    sku: 'SPK-BT-WTRF-BLK',
    images: [
      'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1545454675-3531b543be5d?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: false,
    rating: 4.6,
    averageRating: 4.6,
    reviewCount: 567,
    totalReviews: 567,
    sold: 890,
    totalSold: 890,
    views: 6789,
    tags: ['speaker', 'bluetooth', 'waterproof', 'portable'],
    createdAt: '2023-12-10T11:45:00.000Z',
    updatedAt: '2024-03-22T16:30:00.000Z',
  },
  {
    _id: '19',
    title: 'Phone Case Premium Leather',
    description: 'Genuine leather phone case with card slots and magnetic closure. Compatible with iPhone 14 Pro.',
    price: 34.99,
    stock: 143,
    stockQuantity: 143,
    category: 'Accessories',
    brand: 'Bellroy',
    sku: 'CASE-LTHR-IP14P-BRN',
    images: [
      'https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?w=800&h=1000&fit=crop',
    ],
    status: 'rejected',
    isFeatured: false,
    rating: 4.3,
    averageRating: 4.3,
    reviewCount: 234,
    totalReviews: 234,
    sold: 445,
    totalSold: 445,
    views: 2345,
    tags: ['phone-case', 'leather', 'accessory', 'iphone'],
    createdAt: '2024-03-05T10:00:00.000Z',
    updatedAt: '2024-03-20T09:00:00.000Z',
  },
  {
    _id: '20',
    title: 'Wireless Charger 3-in-1',
    description: 'Fast charging station for iPhone, Apple Watch, and AirPods. Qi-certified with LED indicator.',
    price: 59.99,
    discountPrice: 49.99,
    stock: 78,
    stockQuantity: 78,
    category: 'Electronics',
    brand: 'Belkin',
    sku: 'CHG-WRLS-3IN1-WHT',
    images: [
      'https://images.unsplash.com/photo-1591290619762-c588f1f6e8c7?w=800&h=1000&fit=crop',
    ],
    status: 'active',
    isFeatured: true,
    rating: 4.8,
    averageRating: 4.8,
    reviewCount: 678,
    totalReviews: 678,
    sold: 1234,
    totalSold: 1234,
    views: 8901,
    tags: ['charger', 'wireless', 'apple', 'fast-charging'],
    createdAt: '2024-01-08T14:30:00.000Z',
    updatedAt: '2024-03-18T12:45:00.000Z',
  },
];

// Mock pagination response
export const getMockProductsPage = (
  page: number = 1,
  limit: number = 12
): { data: Product[]; pagination: any } => {
  const start = (page - 1) * limit;
  const end = start + limit;
  const paginatedProducts = mockProducts.slice(start, end);

  return {
    data: paginatedProducts,
    pagination: {
      page,
      limit,
      total: mockProducts.length,
      totalPages: Math.ceil(mockProducts.length / limit),
    },
  };
};

















